module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/qmusc40-931fca147799afac06fbe29647289624.jpg";